/**
 * Enum for URLs for the API endpoints.
 */
import root from 'window-or-global';
import {getPageNoLeadingSlash} from 'epic-node-cms/src/cmsUtils/utils';

export default function url() {
    /**
     * Enum for URLs for the API endpoints.
     */
    let appContext = '';
    if (root.appContext && root.appContext !== '/') {
        ({appContext} = root);
    }

    const {location} = root;
    const port = location.port ? `:${location.port}` : '';

    if (!location.origin) {
        location.origin = `${location.protocol}//${location.hostname}${port}`;
    }
    const origin = location.origin + appContext;

    const isServerRender = root.__server_side_render;

    const finalOrigin = isServerRender ? `http://localhost${port}${appContext}` : origin;

    const url = {
        CMS_PAGE_DATA: (locale, urlPattern) => `${finalOrigin}/api/${locale}/cms/${getPageNoLeadingSlash(urlPattern)}`
    };

    return url;
}
